<template>
  <div class="blog-wrapper">
    <blog-header/>
    <div class="subpage__inner">
      <SubpageNav :links="links" class="DesktopTab"/>
      <div class="mobileTab">
        <!-- <select-box :options="links" title="Girişimcilik"/> -->
        <v-select placeholder="Select Category" :options="links" @onselect="selectCategory"/>
      </div>
      <container>
        <ContentLoader v-if="!blogs && !mobileCheck">
        <rect x="39" y="0" rx="3" ry="3" width="104" height="110" />
        <rect x="149" y="0" rx="3" ry="3" width="104" height="110" />
        <rect x="258" y="0" rx="3" ry="3" width="102" height="110" />
        
        <rect x="39" y="115" rx="3" ry="3" width="104" height="110" />
        <rect x="149" y="115" rx="3" ry="3" width="104" height="110" />
        <rect x="258" y="115" rx="3" ry="3" width="102" height="110" />      
      </ContentLoader>   

      <ContentLoader v-if="!blogs && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="400" height="400" />    
      </ContentLoader> 

        <div class="blog-list col-xl-10 offset-xl-1" v-if="blogs">
<!--           <div class="result-bracket__title">
            <span class="result-bracket__count">{{ blogs.length }}</span> Adet Bulundu!
          </div> -->
          
          <div class="blog-list__item" v-for="blog in blogs" :key="blog.id">
            <blog-card :blog="blog"/>
          </div>

    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>  
           
<!--           <div class="blog-list__bottom">
            <v-button
              class="button--stroke round"
              title="Daha Fazla"
            />
          </div> -->
<!--           <Advert/>
          <AdvertBanner class="banner-mobile"/> -->
        </div>
      </container>
    </div>
  </div>
</template>

<script>
import BlogHeader from '@/components/Blog/BlogHeader'
import BlogCard from '@/components/Blog/BlogCard'
import SubpageNav from '@/components/SubpageNav2'
import Advert from '@/components/Advert'
import AdvertBanner from '@/components/AdvertBanner'
import SelectBox from '@/components/SelectBox'
import InfiniteLoading from 'vue-infinite-loading'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
export default {
  name: 'Blog',
  components: {
    BlogHeader, SubpageNav, BlogCard, Advert, SelectBox, AdvertBanner, InfiniteLoading, ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Blog',
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/blog/' }
      ] 
    }
  },  
  data () {
    return {
      page: 1,
      links: [],
      blogs: [],
      categories: [
        {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "hollywood",
sort: null,
title: "Hollywood",
updated_at: "2019-03-20 10:54:56"          
        },
        {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "filmstudios",
sort: null,
title: "Film Studios",
updated_at: "2019-03-20 10:54:56"          
        },
        {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "netflix",
sort: null,
title: "Netflix",
updated_at: "2019-03-20 10:54:56"          
        }                
      ]
    }
  },
  methods: {   
    infiniteHandler ($state) {
      let self = this
      axios.get(`/site/blogs/list/?page=${this.page}`)
        .then(response => {
            if (response.data.data.length !== 0 ) {              
              response.data.data.forEach(item => {
                self.blogs.push(item)
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },    
    selectCategory(opt) {
      this.$router.push('/blog/kategori/' + opt.value)
    },    
    getAdverts () {
      let self = this
      axios.get('/site/adverts/category/list')
        .then(response => {
          self.blogs = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },    
    getBlogs () {
      let self = this
       const yesterday = new Date(Date.now() - 1 * 86400000 - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0]
      axios({ url: `everything?q=hollywood&from=${yesterday}&sortBy=publishedAt&apiKey=e34edc1310254cb789cc1c918c5f88c7`, baseURL: 'https://newsapi.org/v2/' })
        .then(response => {
          self.blogs = response.data.articles
        })
        .catch(e => {
          this.errors.push(e)
        })
    },   
    getCategories () {
          this.links = this.categories.map((item) => {
            return {
              id: item.id,
              title: item.title,
              name: item.title,
              value: item.slug,
              to: { name: 'BlogCategory', params: { slug: item.slug } }
            }
          })
    }
  },
  created () {
    this.getBlogs()
    this.getCategories()
    // this.getAdverts ()
  },
computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },    
}
}
</script>

<style lang="scss">
  @import "../assets/scss/components/blog";
</style>
